import Styleguide from "@store/Framework/Types/Styleguide";

const zIndex: Styleguide["zIndex"] = {
    stickyFooter: 1286,
};

export default zIndex;
